import { render, staticRenderFns } from "./PacienteList.vue?vue&type=template&id=dfea2a9a&"
import script from "./PacienteList.vue?vue&type=script&lang=js&"
export * from "./PacienteList.vue?vue&type=script&lang=js&"
import style0 from "./PacienteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports